
<template>
  <div class="editor-modal" v-if="finished == false">
    <header class="editor-header">
      <Heading text="New HiLite" />
    </header>
    <Player type="json" :video="editor.video" :player="editor.player" :pauseVdOnUpdate="mode == 'cut' ? true : false" ref="editorPlayer">
      <template v-slot:below-player-content>
        <Overlay v-if="mode">
          <keep-alive>
            <Cut v-if="mode === 'cut' && clipArrayForCut.length > 0" :clipsForCut="clipArrayForCut" />
            <PanZoom v-if="mode === 'panzoom'" :editor="editor" />
            <Music v-if="mode === 'music'" :music="editor.music" :editor="editor" />
          </keep-alive>
        </Overlay>
      </template>
    </Player>
    <footer class="editor-footer">
      <div class="edit-section">
        <h5 class="edit-section-header">
          <span>Edit</span>
        </h5>
        <div class="edit-section-content">
          <div class="editor-steps">
            <div
              v-on:click="changeMode('cut')"
              :class="{ active: mode === 'cut', previous: mode === 'panzoom' || mode == 'music'}"
              class="editor-step cut"
            > <span>Cut</span></div>
            <div
              v-on:click="changeMode('panzoom')"
              :class="{ active: mode === 'panzoom', previous: mode === 'music'}"
              class="editor-step panzoom"
            ><span>Pan</span></div>
            <div
              v-on:click="changeMode('music')"
              :class="{ active: mode === 'music' }"
              class="editor-step music"
            ><span>Add Music</span></div>
          </div>
          <div class="prev-next">
            <div class="previous button" :class="{disabled: mode === modes[0]}" v-on:click="prevNext('prev')">Previous</div>
            <div class="next button" :class="{disabled: mode === modes[modes.length - 1]}" v-on:click="prevNext('next')">Next</div>
          </div>
        </div>
      </div>
      <div class="save-cancel">
        <div class="secondary button" v-on:click="closeEditor">Cancel</div>
        <div class="primary button" v-on:click="finishEditing">Finish</div>
      </div>
    </footer>
  </div>

  <div v-else class="editor-modal finished">
    <Success :video="editor.video">
      <Player type="json" :video="editor.video" :player="editor.player" ref="editorPlayer" />
    </Success>
  </div>

</template>

<script>
import VideoJS from "@/components/VideoJS";
import Player from "@/components/Player";
import Overlay from "@/components/editor/Overlay";
import PanZoom from "@/components/editor/PanZoom";
import Music from "@/components/editor/Music";
import Cut from "@/components/editor/Cut";
import Success from "@/components/editor/Success";
import Vue from "vue";

export default {
  name: "Editor",
  props: ["editor", "video"],
  components: {
    Player, VideoJS, Overlay, PanZoom, Music, Cut, Success
  },
  data() {
    return {
      useOffset: true,
      finished: false,
      mode: "cut",
      clipArrayForCut: [],
      modes: [
        "cut",
        "panzoom",
        "music"
      ]
    }
  },
  mounted() {
     //setup clips for cut feature
     const segments = this.editor.video.clipManifest.segments;
     const edgeSegments = this.editor.video.clipManifest.edgeSegments;

     let clipArr = [];

     segments.forEach(function(clip) {
       clip = _.cloneDeep(clip);
       Vue.set(clip, "selected", true);
       clipArr.push(clip);
     });

     if (edgeSegments) {
       edgeSegments.forEach(function(clip) {
         clip = _.cloneDeep(clip);

         Vue.set(clip, "selected", false);
         if (clip.side == "front") {
           clipArr.unshift(clip);
         } else if (clip.side == "back") {
           clipArr.push(clip);
         }
       });
     }

     this.clipArrayForCut = clipArr;
  },
  methods: {
    closeEditor: function() {
      this.$store.commit("setMode", "player");
    },
    finishEditing: function() {
      this.editor.player.viewMode = "VirtualDirector";
      this.finished = true;
    },
    changeMode: function(mode) {
      //if prev.
      if (this.modes.findIndex((element) => element == mode) < this.modes.findIndex((element) => element == this.mode)) {
        this.mode = mode;
      }
    },
    prevNext: function(direction) {
      let currentIndex = this.modes.findIndex((element) => element == this.mode);
      if (direction == "next" && this.modes[currentIndex + 1]) {
        this.mode = this.modes[currentIndex + 1]
      }
      if (direction == "prev" && this.modes[currentIndex - 1]) {
        this.mode = this.modes[currentIndex - 1]
      }
    }
  },
  watch: {
    mode: {
      handler(value) {
        if (this.mode == "panzoom") {
          this.editor.player.swapVMOnPlay = true;
          if (this.editor.player.playing == true) {
            this.editor.player.viewMode = "VirtualDirector";
          } else if (this.editor.player.playing == false) {
            this.editor.player.viewMode = "Free View";
          }
        } else {
          this.editor.player.swapVMOnPlay = false;
          this.editor.player.viewMode = "VirtualDirector";
        }
      }
    }
  }
};
</script>

<style lang="stylus">
.editor-modal
  width: 100%
  height: auto
  max-width: 820px
  margin: auto
  overflow: hidden
  border-radius: 15px
  box-shadow: 0px 0px 25px 0px rgba(0,0,0,0.25)
  .vjs-big-play-button
    display: none!important
.editor-header
  padding: 15px 30px
  h1
    font-size: 22px
.editor-footer
  position: relative
  padding: 30px
  display: flex
  justify-content: flex-start
  align-items: center
  .button
    margin-left: 10px
    color: #001249
    border: 1px solid #D1D1D1
    border-radius: 5px
    color: inherit
    font-weight: 600
    text-decoration: none
    padding: 8px 20px
    cursor: pointer
    &.disabled
      color: #d1d1d1
      opacity: 0.5
      cursor: default
    &:not(.disabled):not(.secondary):not(.primary):hover
      background: linear-gradient(to bottom, #ffffff 0%,#EFEFEF 100%);
      &:active
        background: linear-gradient(to bottom, #EFEFEF 0%,#ffffff 100%);
    &.primary
      background: linear-gradient(to bottom, #f05f38 0%, #d85633 100%)
      border-color: #FFF
      color: #FFF
      &:hover
        background: linear-gradient(to bottom, #f05f38 0%, #B03B1B 100%)
        &:active
          background: linear-gradient(to bottom, #B03B1B 0%, #f05f38 100%)
  .save-cancel, .prev-next
    display: flex
    align-items: center
  .save-cancel
    margin-left: auto
    margin-top: 17px
    .secondary
      border: none
      padding: 0px
      margin-right: 10px
      border-radius: 0px
      position: relative
      &:hover
        &:after
          content: ""
          width: 100%
          background: none
          border-bottom: 2px solid #000
          position: absolute
          bottom: 0px
          left: 0px
  .edit-section
    display: flex
    flex-basis: 570px
    overflow: hidden
    flex-wrap: wrap
    justify-content: space-around
    .edit-section-content
      width: 100%
      display: flex
      align-items: center
      justify-content: space-between
    .edit-section-header
      width: 100%
      margin: 0px
      font-size: 16px
      line-height: 100%
      text-align: center
      position: relative
      span
        padding: 0px 10px
        color: #001249
        background: #FFF
        z-index: 5
        position: relative
      &:before
        content: ''
        height: 1px;
        background: #d1d1d1
        width: 100%
        position: absolute
        top: 0px
        bottom: 0px
        margin: auto
        left: 0px
        z-index: 0
    .editor-steps
      display: flex
      .editor-step
        height: 60px
        margin-right: 10px
        padding-left: 50px
        cursor: pointer
        color: #BBBBBB
        background-position: left center
        background-repeat: no-repeat
        background-size: auto 17px
        display: flex
        align-items: center
        opacity: 1;
        &:after
          content: ""
          background: #d1d1d1
          height: 1px
          width: 50px
          margin-left: 10px
        &:last-of-type
          &:after
            content: none
        span
          line-height: 100%
          font-weight: bold
        &.previous
          color: #001F4D
        &.active
          color: #D85633
        &:last-of-type
          margin-right: 0px
        &.cut
          background-image: url("../../assets/images/cut-grey.svg")
          padding-left: 32px
          &.active
            background-image: url("../../assets/images/cut-orange.svg")
          &.previous
            background-image: url("../../assets/images/cut-blue.svg")
        &.panzoom
          background-image: url("../../assets/images/pan-grey.svg")
          padding-left: 26px
          &.active
            background-image: url("../../assets/images/pan-orange.svg")
          &.previous
            background-image: url("../../assets/images/pan-blue.svg")
        &.music
          background-image: url("../../assets/images/music-grey.svg")
          padding-left: 18px
          &.active
            background-image: url("../../assets/images/music-orange.svg")
          &.previous
            background-image: url("../../assets/images/music-blue.svg")
</style>
